import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    setTimeout(() => {
      // Find the closest parent div element
      const parentDiv = this.element.closest("[role='convo']");

      if (parentDiv) {
        // Scroll the parent div to the bottom
        parentDiv.scrollTop = parentDiv.scrollHeight;
      }
    }, 50);
  }
}
